import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.background.light,
  },
}));
